// extracted by mini-css-extract-plugin
module.exports = {"security":"Security_security__RraKu"};